import { Public } from '../types';
import { IHttpService } from './http-service';
import { HttpMethod } from './types';

/** Public interface of @see ProcessEngineService. */
export type IProcessEngineService = Public<ProcessEngineService>;

export class ProcessEngineService {
  static readonly baseUrl = '/process-engine/v2/app';

  private _httpService: IHttpService;

  constructor(
    httpService: IHttpService
  ) {
    this._httpService = httpService;
  }

  async runTest(
    branchId: string,
    version: string,
    body: string,
    headers: Record<string, string>
  ): Promise<any> {
    return (await this._httpService.fetchJsonOrFail({
      body,
      method: HttpMethod.post,
      url: `${branchId}/${version}/run`,
      headers
    }));
  }
}
